

const skyBlueBackgroundClass = `bg-sky-200`

const UnitsToProduce = ({ score25, score50, score75, unitsToSell, sum_rog_25, sum_rog_50, sum_rog_75, forecastType, FORECASTTYPEOPTIONS, sort, time }) => {

  return <>

    {forecastType == FORECASTTYPEOPTIONS[0] ? <td className={` border-r border-r-slate-300 ${sort.split('-')[0] == `${time}score75` ? skyBlueBackgroundClass : ''}`}>
      <div>Score:{score75}</div>
      <div>Units to produce ={parseInt(score75 * unitsToSell / sum_rog_75)}</div>

    </td> : null}
    {forecastType == FORECASTTYPEOPTIONS[1] ? <td className={` border-r border-r-slate-300 ${sort.split('-')[0] == `${time}score50` ? skyBlueBackgroundClass : ''}`}>
      <div>Score:{score50}</div>
      <div>Units to produce ={parseInt(score50 * unitsToSell / sum_rog_50)}</div>

    </td> : null}
    {forecastType == FORECASTTYPEOPTIONS[2] ? <td className={` border-r-2 border-r-slate-800 ${sort.split('-')[0] == `${time}score25` ? skyBlueBackgroundClass : ''}`}>
      <div>Score:{score25}</div>
      <div>Units to produce ={parseInt(score25 * unitsToSell / sum_rog_25)}</div>

    </td> : null}
  </>

}

export default UnitsToProduce
